import React from 'react'
import { Field } from 'formik'
import { Toggle } from 'libreact/lib/Toggle'

import Width from '../../../Width'
import Items from './Items'
import Row from '../../../Row'
import Input from '../../../Input/index'
import Checkbox from './Checkbox/index'
import enabled from './lib/enabled'
import onClickInput from './lib/onClickInput'
import onChangeInput from './lib/onChangeInput'

const editable = ({ custom, filled, label }) => (custom && !filled) || !label

export default ({ noTopLine, form, baseName, items, on, isItem, ...rest }) => (
  <Toggle init={on}>
    {({ on, toggle }) => (
      <Width>
        {({ isSmall }) => (
          <div>
            <Row noTopLine={noTopLine}>
              <Checkbox
                baseName={baseName}
                on={on}
                toggle={toggle}
                items={items}
                isItem={isItem}
                editable={editable(rest)}
                {...rest}
              />
              {!(isSmall && editable(rest)) && <Field name={`${baseName}.value`}>
                {({ field }) => (
                  <Input
                    disabled={!enabled(form, baseName)}
                    onClick={onClickInput(form, baseName, isItem, items, on, toggle)}
                    readOnly={!!items}
                    {...field}
                    onChange={onChangeInput(form, field, baseName, isItem)}
                  />
                )}
              </Field>}
            </Row>

            {items && on && <Items form={form} baseName={`${baseName}.items`} />}
          </div>
        )}
      </Width>
    )}
  </Toggle>
)
